// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1qMXn","left":"StickyBox_left__3G_i9","right":"StickyBox_right__5AVM4"};